import React from "react";
import { ReactComponent as LogoutSvg } from "../../assets/settingPage/Logout.svg";
import { ReactComponent as LogoutSvgDark } from "../../assets/settingPage/Logout-dark.svg";
// redux
import { useDispatch, useSelector } from "react-redux";
import {
  logoutUser,
  resetUser as resetAuthUser,
} from "../../redux/slices/auth/authSlice";
import { resetLinkList } from "../../redux/slices/gettingLinksList/gettingLinkListSlice";
import { useNavigate } from "react-router-dom";
import useLocales from "../../hooks/useLocales";
import useSettings from "../../hooks/useSettings";

// Mobile screen logout button

const MobileBottomLogoutBtn = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { translate } = useLocales();
  const { themeDirection } = useSettings();
  const logoutaHndler = () => {
    dispatch(logoutUser());
    dispatch(resetLinkList());
    dispatch(resetAuthUser());
    navigate("/auth/login");
  };
  return (
    <button
      type="button"
      onClick={logoutaHndler}
      className="flex md:hidden gap-2.5 items-center my-11"
    >
      {darkMode ? (
        <LogoutSvgDark
          className={`${
            themeDirection === "rtl" ? "transform -scale-x-100" : ""
          }`}
        />
      ) : (
        <LogoutSvg
          className={`${
            themeDirection === "rtl" ? "transform -scale-x-100" : ""
          }`}
        />
      )}
      <p className="text-small1 dark:text-color_v1_dark">
        {/* Logout */}
        {translate("header.logout")}
      </p>
    </button>
  );
};

export default MobileBottomLogoutBtn;
